<template>
  <v-row>
    <v-col lg="10" class="mx-auto">
      <v-card class="pa-4">
        <ValidationObserver ref="form" v-slot="{ errors, failed, invalid }" slim>
          <v-form>
            <v-row>
              <v-col>
                <p class="subtitle-2 mb-1">{{ $t('目前身份') }}</p>
                <p>{{ user.vendor.no }} {{ user.vendor.name }}</p>
              </v-col>
              <v-col cols="auto" class="ml-auto">
                <v-btn
                  href="https://icinfo.immigration.gov.tw/NIL_WEB/NFCData.aspx"
                  target="_blank"
                  depressed
                  color="primary"
                >
                  {{ $t('居留證查詢') }}
                  <v-icon right>mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <p class="subtitle-2 mb-0">
              <label for="identityType" class="required">{{ $t('請選擇證件類別') }}</label>
            </p>
            <v-select
              id="identityType"
              :items="identityTypes"
              item-text="text"
              item-value="value"
              v-model="form.identity_type"
            ></v-select>
            <v-btn
              v-if="form.identity_type == 'ID'"
              href="https://www.ris.gov.tw/app/portal/3014#content-frame"
              target="_blank"
              color="info"
              depressed
            >
              <v-icon>mdi-open-in-new</v-icon>
              {{ $t('身分證驗證') }}
            </v-btn>
            <ValidationProvider name="證號" rules="required" slim>
              <p class="subtitle-2 mt-3 mb-0">
                <label for="identityNo" class="required">{{ $t('請輸入證號') }}</label>
              </p>
              <v-text-field
                id="identityNo"
                :value="form.no"
                @input="value => form.no = value.replace(/[^0-9a-z]/gi, '').toLocaleUpperCase()"
                autofocus
              />
            </ValidationProvider>
            <p class="subtitle-2 mt-3 mb-0">
              <label for="birthday">{{ $t('請輸入生日') }}</label>
            </p>
            <ValidationProvider
              :name="$t('生日')"
              rules="birthday"
              :custom-messages="{required: $t('生日 為必填')}"
              v-slot="{ errors }"
              slim
              vid="birthday"
            >
              <v-text-field
                :label="$t('生日')"
                id="birthday"
                placeholder="YYYY-MM-DD"
                class="align-baseline"
                v-model="form.birthday"
                v-mask="'date-iso'"
                :error-messages="errors[0]"
              >
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="國籍"
              :custom-messages="{required: $t('國籍 為必填')}"
              v-slot="{ errors }"
              slim
            >
              <p class="subtitle-2 mt-3 mb-0">
                <label for="nationality">{{ $t('國籍') }}</label>
              </p>
              <v-autocomplete
                id="nationality"
                :items="nationalityOptions"
                :item-text="item => $t(item.text)"
                :error-messages="errors[0]"
                v-model="form.nationality"
              />
            </ValidationProvider>
            <v-btn
              color="primary"
              large
              block
              @click="submit"
              :loading="isLoading"
              :disabled="invalid"
            >
              <v-icon>mid-magnify</v-icon>
              {{ $t('確定送出') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-card>
      <v-card class="pa-4 mt-4">
        <query-logs-table
          :isLoading="isLoading"
          :items="items"
          :items-per-page="-1"
        >
        </query-logs-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import QueryLogsTable from '../../components/QueryLogsTable';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { NATIONALITY_OPTIONS } from '../../libs/const';
import { mask } from '@titou10/v-mask';

const EMPTY_FORM = () => ({
  identity_type: 'passport',
  no: null,
  nationality: null,
  birthday: null,
});

export default {
  components: {
    QueryLogsTable,
    ValidationObserver,
    ValidationProvider,
  },

  directives: {
    mask,
  },

  data() {
    return {
      isLoading: false,
      birthdayMenu: false,
      form: EMPTY_FORM(),
      nationalityOptions: NATIONALITY_OPTIONS.filter(item => item.value !== 6),
      items: [],
    };
  },

  computed: {
    identityTypes() {
      return [
        {
          text: this.$t('護照號碼'),
          value: 'passport',
        },
        // {
        //   text: this.$t('身分證字號'),
        //   value: 'ID',
        // },
      ];
    },
    ...mapState('queries', {
      queryLogs: 'all'
    }),
    ...mapState(['user']),
  },

  async mounted() {
    if (this.queryLogs.length) {
      this.items = [...this.queryLogs];
      return;
    }

    this.isLoading = true;
    await this.getQueryLogs({
      per_page: 20,
    });
    this.items = [...this.queryLogs];
    this.isLoading = false;
  },

  methods: {
    async submit() {
      this.isLoading = true;
      try {
        let log = await this.query({
          ...this.form,
          vendor_id: this.user.vendor.id,
          sim_type: '4G',
        });

        this.items.unshift(log);
        this.form = EMPTY_FORM();
        this.$refs.form.reset();
      } catch (error) {
        console.error(error);
        alert(this.$t('當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝'));
      }
      this.isLoading = false;
    },

    ...mapActions('queries', {
      'getQueryLogs': 'get',
      'query': 'create'
    }),
  },
}
</script>

<style lang="scss" scoped>
label.required {
  &:after {
    content: '*';
    color: red;
  }
}
</style>
